var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoBill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_722_6488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.332 20.5C10.332 14.9772 14.8092 10.5 20.332 10.5H30.332C35.8549 10.5 40.332 14.9772 40.332 20.5V40.5H20.332C14.8092 40.5 10.332 36.0228 10.332 30.5V20.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_6488)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_722_6488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.3333 23.9766V21.8516H22V23.9766H31.3333ZM31.3333 19.7266C31.687 19.7266 32.0261 19.8758 32.2761 20.1415C32.5262 20.4072 32.6667 20.7675 32.6667 21.1432V28.2266C32.6667 28.6023 32.5262 28.9626 32.2761 29.2283C32.0261 29.494 31.687 29.6432 31.3333 29.6432H22C21.6464 29.6432 21.3072 29.494 21.0572 29.2283C20.8071 28.9626 20.6667 28.6023 20.6667 28.2266V21.1432C20.6667 20.7675 20.8071 20.4072 21.0572 20.1415C21.3072 19.8758 21.6464 19.7266 22 19.7266H31.3333ZM19.3333 31.0599H29.3333V32.4766H19.3333C18.9797 32.4766 18.6406 32.3273 18.3905 32.0616C18.1405 31.796 18 31.4356 18 31.0599V23.2682H19.3333V31.0599Z",
    fill: "url(#paint0_linear_722_6488)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_722_6488",
    x: 0.332031,
    y: 0.5,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.589833 0 0 0 0 0.108333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_722_6488"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_722_6488",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_722_6488",
    x1: 18,
    y1: 19.7266,
    x2: 32.6667,
    y2: 19.7266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF6AB3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_6488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 17,
    fill: "white",
    transform: "translate(17.332 16.8105)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_722_6488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 17,
    fill: "white",
    transform: "translate(17.332 16.8105)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBill);
export default __webpack_public_path__ + "static/media/ico-bill.960cf5a39628cffbf4591f470c9ee824.svg";
export { ForwardRef as ReactComponent };